import {
  TEMPLATE_ACTIVE_STATUS,
  TEMPLATES_FILTER_MAPPING,
} from '@common/constants';
import {
  MUI_TABLE_FILTER_OPERATORS,
  isNumberOperator,
} from '@common/helpers/filterOperators';
import { isValidValue } from './helpers';

const getAdvancedFiltersForMUITable = (values = {}, isValueOptional) => {
  const activeFilters = values?.items;
  if (!activeFilters?.length) return;

  const { field, value, operator } = activeFilters[0];

  if (!field || !operator || (!isValueOptional && !isValidValue(value))) {
    return;
  }

  const backendField = TEMPLATES_FILTER_MAPPING[field] || field;

  return [
    {
      key: backendField,
      operation: MUI_TABLE_FILTER_OPERATORS[operator],
      value: isValueOptional ? null : value,
    },
  ];
};

const isNotNumberValue = (value) => {
  return isNaN(Number(value));
};

export const onTabsTableFilterChange = (values) => {
  const lastActiveFilter = values?.items[0];

  if (!lastActiveFilter) {
    return [];
  }

  const { operator, value } = lastActiveFilter;

  const isValueOptional = ['isNotEmpty', 'isEmpty'].includes(operator);

  if (isNumberOperator(operator) && isNotNumberValue(value)) {
    return [];
  }

  const advancedFilters = getAdvancedFiltersForMUITable(
    values,
    isValueOptional,
  );

  if (!advancedFilters) {
    return [];
  }

  return advancedFilters;
};

const isDeepEqual = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
};

export const isAdvancedFilterChanged = ({
  advancedFilters,
  filterAndSortParams,
}) => {
  if (
    Boolean(advancedFilters) !==
    Boolean(filterAndSortParams?.filters?.advancedFilters)
  ) {
    return true;
  }

  return (
    advancedFilters &&
    !isDeepEqual(advancedFilters, filterAndSortParams?.filters?.advancedFilters)
  );
};

export const getIsArchivedFilterActive = (filterAndSortParams) => {
  const activeFilter = filterAndSortParams?.filters?.advancedFilters[0];

  if (activeFilter?.key !== TEMPLATES_FILTER_MAPPING.isActive) {
    return null;
  }

  if (activeFilter?.value === true) {
    return TEMPLATE_ACTIVE_STATUS.ACTIVE;
  }

  if (activeFilter?.value === false) {
    return TEMPLATE_ACTIVE_STATUS.ARCHIVED;
  }

  return null;
};
